__webpack_require__.p = "https://ichef-cloud2-production.s3.ap-northeast-1.amazonaws.com/online_restaurant_frontend/shared/2.321.0/";